import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { DocumentService } from "../../../services";
import { toast } from "react-toastify";
import { handleConsoleError } from "../../../utils/common-methods";

const EventDocument = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [eventID, setEventID] = useState("");
  const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const pdfHtmlContent = useState(""); // State for storing the PDF content
  const pdfContentRef = React.createRef(); // Ref for the hidden container
  //const [pdfBase64, setPdfBase64] = useState("");
  // const [pdfFile, setPdfFile] = useState(null);
  const { eventId } = useParams();

  useEffect(() => {
    getData(eventId);
  }, []);

  // Event Document List
  const getData = async (eventId) => {
    props.application.setLoading(true);
    try {
      const res = await DocumentService.getEventDocumentEventById(eventId);
      if (res?.isSuccess) {
        const firstEventId = res?.data?.[0]?.eventId;
        setEventID(firstEventId || "");
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleEdit = async (id) => {
    try {
      DocumentService.setDocumentId(id);
      navigate(routes.EVENT_CREATE_DOCUMENT.replace(":eventId", eventId));
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleCreateDoc = async (EventId) => {
    DocumentService.removeDocumentId(); //change
    try {
      navigate(routes.EVENT_CREATE1_DOCUMENT.replace(":eventId", eventId));
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (!confirmDelete) {
      return; // Exit if the user cancels
    }

    try {
      props.application.setLoading(true);
      const response = await DocumentService.DeleteEventDocument(id);
      if (response?.isSuccess) {
        toast.success("Record deleted successfully");
        getData(eventId);
      } else {
        toast.error(response?.message || "Failed to delete the record");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(
        error?.message || message
      );
    } finally {
      props.application.setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <section className="subscription-banner p-0">
        <div className="container">
          <h3>
            Upload Your Trader Contracts & Communication Documentation{" "}
            <p className="sub-heading-text">
              (Which is displayed on your live event listing)
            </p>
          </h3>
        </div>
      </section>
      <section className="edit-form-table">
        <div className="container">
          <div className="verifier-buttton">
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleCreateDoc(eventID);
              }}
            >
              Create New Document
            </Button>{" "}
          </div>

          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Event Name</th>
                  <th>Document Name</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.eventName}</td>
                          <td>{item?.documentName}</td>
                          <td>
                            {item?.isActive === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            <div className="delete-create">
                              <Link
                                title="Edit Document"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>

                              <Link
                                title="Delete Document"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>

        {/* <div
          ref={pdfContentRef}
          dangerouslySetInnerHTML={{ __html: pdfHtmlContent }}
        /> */}
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventDocument);
